import { Form, Select } from 'antd';
import { fieldIsRequired, shoolYearList } from '../../constants/constants';
import { selectHerePlaceholder } from '../../constants/translations';

export const ShoolYearSelection = () => (
  <Form.Item
    label="Mokslo metai"
    name={['registration', 'schoolYear']}
    rules={[fieldIsRequired]}
  >
    <Select placeholder={selectHerePlaceholder} showSearch={true}>
      {shoolYearList.map((schoolYear, index) => (
        <Select.Option key={`period_item_${index + 1}`} value={schoolYear}>
          {schoolYear}
        </Select.Option>
      ))}
    </Select>
  </Form.Item>
);
